module.exports = __webpack_public_path__ + "fonts/Rubik-Medium.4ddab52.ttf";